module.exports = __webpack_public_path__ + "img/edit_black_24dp.94d12096.svg";